/* Mojbrend.ba — nova tema, globalni JS (bez zavisnosti). */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Drawers (meni, korpa, filteri) ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = d.querySelector('button, a, input');
    if (f) f.focus();
  }
  const DRAWERS = '.mb-drawer, .mb-subcats__sheet, .mb-menu';
  function closeDrawer(d) {
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    if (!$$('.mb-drawer[aria-hidden="false"], .mb-subcats__sheet[aria-hidden="false"], .mb-menu[aria-hidden="false"]').length) document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawerOpen); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest(DRAWERS)); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.mb-drawer[aria-hidden="false"], .mb-subcats__sheet[aria-hidden="false"], .mb-menu[aria-hidden="false"]').forEach(closeDrawer);
  });
  window.mbOpenDrawer = openDrawer;

  /* ---------- Glavni meni: isti HTML – mobile = tabovi + accordion, desktop = hover mega ---------- */
  const menu = $('#MbMenu');
  if (menu) {
    const groups = $$('.mb-menu__item--group', menu);
    menu.style.setProperty('--mb-tabs', String(Math.max(1, groups.length)));
    const first = groups[0] && groups[0].querySelector('.mb-menu__btn');
    if (first) first.setAttribute('aria-expanded', 'true');
    menu.addEventListener('click', (e) => {
      const top = e.target.closest('.mb-menu__item--group > .mb-menu__btn');
      if (top) {
        groups.forEach((g) => g.querySelector('.mb-menu__btn').setAttribute('aria-expanded', g.contains(top) ? 'true' : 'false'));
        return;
      }
      const sub = e.target.closest('.mb-menu__sub');
      if (sub && window.innerWidth < 900) sub.setAttribute('aria-expanded', sub.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  }

  /* ---------- Desktop mega meni: pozicija panela ispod headera ---------- */
  function setNavOffset() {
    const h = $('.mb-header');
    if (h) document.documentElement.style.setProperty('--mb-nav-offset', h.getBoundingClientRect().bottom + 'px');
  }
  setNavOffset();
  window.addEventListener('resize', setNavOffset);
  window.addEventListener('scroll', setNavOffset, { passive: true });

  /* ---------- Kolekcija: tagovi podkategorija – scroll indikator + fade + „Prikaži sve“ ---------- */
  $$('.mb-subcats__scroll').forEach((wrap) => {
    const list = wrap.querySelector('.mb-subcats__list');
    const thumb = wrap.parentElement.querySelector('.mb-subcats__track b');
    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      wrap.classList.toggle('is-end', max <= 2 || list.scrollLeft >= max - 2);
      if (thumb && max > 0) {
        const track = thumb.parentElement.clientWidth;
        const w = Math.max(28, track * (list.clientWidth / list.scrollWidth));
        thumb.style.width = w + 'px';
        thumb.style.left = (list.scrollLeft / max) * (track - w) + 'px';
      } else if (thumb) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
      }
    };
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Faceti spol / dostupnost: button u <form>, navigacija JS-om (nema <a href> za Google) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.mb-facet-form button[data-href]');
    if (b) { e.preventDefault(); window.location.assign(b.dataset.href); }
  });
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-href-toggle]')) {
      window.location.assign(t.checked ? t.dataset.hrefOn : t.dataset.hrefOff);
    }
    if (t.matches('[data-sort]')) {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', t.value);
      u.searchParams.delete('page');
      window.location.assign(u.toString());
    }
  });

  /* ---------- Paging: Prethodna / Sljedeća kao JS dugmad ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.mb-paging__btn[data-href]');
    if (b && !b.disabled) window.location.assign(b.dataset.href);
  });

  /* ---------- PDP: galerija (dots + thumbs) ---------- */
  $$('.mb-gallery').forEach((g) => {
    const track = g.querySelector('.mb-gallery__track');
    const dots = $$('.mb-gallery__dots i', g);
    const thumbs = $$('.mb-gallery__thumbs button', g);
    const n = track.children.length;
    const setActive = (i) => {
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    };
    track.addEventListener('scroll', () => setActive(Math.round(track.scrollLeft / track.clientWidth)), { passive: true });
    thumbs.forEach((t, i) => t.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' })));
    g.addEventListener('mb:slide', (e) => {
      const i = Math.max(0, Math.min(n - 1, e.detail));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    });
  });

  /* ---------- PDP: varijante, cijena, zaliha, sticky bar ---------- */
  const pdp = $('[data-mb-product]');
  if (pdp) {
    const data = JSON.parse(pdp.querySelector('[data-product-json]').textContent);
    let inv = {};
    try { inv = JSON.parse(pdp.querySelector('[data-inventory-json]').textContent); } catch (e) {}
    const lowLimit = parseInt(pdp.dataset.low || '8', 10);
    const form = pdp.querySelector('form[data-product-form]');
    const idInput = form.querySelector('input[name="id"]');
    const cta = form.querySelector('[data-add]');
    const buyNow = form.querySelector('[data-buy-now]');
    const sticky = $('.mb-sticky');
    const priceTpl = (pdp.querySelector('[data-price]') || {}).textContent || '';
    const fmt = (c) => {
      const n = (c / 100).toFixed(2).replace('.', ',');
      return /KM/.test(priceTpl) ? n + ' KM' : n;
    };
    const fieldsets = $$('.mb-variants fieldset', pdp);

    function currentVariant() {
      const opts = fieldsets.map((f) => (f.querySelector('input:checked') || {}).value);
      return data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    function render() {
      const v = currentVariant();
      fieldsets.forEach((f, i) => {
        const sel = pdp.querySelector('[data-selected-option="' + i + '"]');
        const c = f.querySelector('input:checked'); if (sel && c) sel.textContent = c.value;
      });
      const allChosen = fieldsets.every((f) => f.querySelector('input:checked'));
      if (!allChosen) { cta.disabled = false; cta.textContent = cta.dataset.addLabel; return; }
      if (!v) { cta.disabled = true; cta.textContent = cta.dataset.unavailable; return; }
      const vb = pdp.querySelector('.mb-variants'); if (vb) vb.classList.remove('is-invalid');
      idInput.value = v.id;
      $$('[data-price]').forEach((el) => (el.textContent = fmt(v.price)));
      $$('[data-compare]').forEach((el) => { el.hidden = !(v.compare_at_price > v.price); el.textContent = fmt(v.compare_at_price || 0); });
      const saveEl = $('[data-save]');
      if (saveEl) { const s = (v.compare_at_price || 0) - v.price; saveEl.hidden = !(s > 0); saveEl.textContent = saveEl.dataset.label.replace('%s', fmt(s)); }
      const stock = $('[data-stock]');
      if (stock) {
        const q = inv[String(v.id)];
        if (v.available) {
          const low = typeof q === 'number' && q > 0 && q <= lowLimit;
          stock.className = low ? 'low' : 'in';
          stock.textContent = low ? stock.dataset.lowtext.replace('%d', q) : stock.dataset.in;
        } else { stock.className = 'out'; stock.textContent = stock.dataset.out; }
      }
      cta.disabled = !v.available;
      cta.textContent = v.available ? cta.dataset.addLabel : cta.dataset.soldout;
      $$('[data-add-sticky]').forEach((b) => { b.disabled = !v.available; b.textContent = cta.textContent; });
      if (buyNow) buyNow.hidden = !v.available;
      if (v.featured_media && v.featured_media.id) {
        const slides = $$('.mb-gallery__slide', pdp);
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(v.featured_media.id));
        const g = $('.mb-gallery', pdp);
        if (idx > -1 && g) g.dispatchEvent(new CustomEvent('mb:slide', { detail: idx }));
      }
      const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    pdp.addEventListener('change', (e) => { if (e.target.matches('.mb-variants input')) render(); });
    if (fieldsets.length) render();

    /* Sticky bar: vidljiv kad glavni CTA izađe iz vidika (iznad ekrana) */
    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky');
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting),
        { rootMargin: '-60px 0px 0px 0px', threshold: 0 }).observe(cta);
      sticky.querySelector('[data-add-sticky]').addEventListener('click', () => {
        form.requestSubmit ? form.requestSubmit() : cta.click();
      });
    }

    /* AJAX dodavanje u korpu -> cart drawer */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const goCheckout = !!(e.submitter && e.submitter.hasAttribute('data-buy-now'));
      if (fieldsets.length && !fieldsets.every((f) => f.querySelector('input:checked'))) {
        const vb = pdp.querySelector('.mb-variants'); vb.classList.add('is-invalid');
        vb.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
      }
      const btns = [cta, buyNow, ...$$('[data-add-sticky]')].filter(Boolean);
      btns.forEach((b) => { b.disabled = true; });
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Greška');
        if (goCheckout) { window.location.href = '/checkout'; return; }
        await refreshCartDrawer();
        openDrawer('MbCartDrawer');
      } catch (err) { window.alert(err.message); }
      finally { btns.forEach((b) => { b.disabled = false; }); }
    });
  }

  /* ---------- Dialog (tabela veličina) ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-dialog-open]');
    if (o) { const d = document.getElementById(o.dataset.dialogOpen); if (d && d.showModal) d.showModal(); return; }
    const c = e.target.closest('[data-dialog-close]');
    if (c) { const d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Očekivani datum isporuke (preneseno iz live teme) ---------- */
  $$('[data-delivery-days]').forEach((box) => {
    const m = (box.dataset.deliveryDays || '').match(/(\d+)-(\d+)/);
    const minD = m ? parseInt(m[1], 10) : 1, maxD = m ? parseInt(m[2], 10) : 2;
    const addBiz = (d, n) => { const x = new Date(d); let a = 0; while (a < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6) a++; } return x; };
    const now = new Date(), dow = now.getDay(), extra = (dow >= 1 && dow <= 5 && now.getHours() < 15) ? 0 : 1;
    const s = addBiz(now, minD + extra), en = addBiz(now, maxD + extra);
    const months = ['januar','februar','mart','april','maj','jun','jul','august','septembar','oktobar','novembar','decembar'];
    const out = box.querySelector('[data-delivery-date]');
    if (out) out.textContent = s.getDate() + './' + en.getDate() + '. ' + months[en.getMonth()];
  });

  /* ---------- Product kartica: chevroni slika + brzo dodavanje ---------- */
  document.addEventListener('click', async (e) => {
    const nav = e.target.closest('[data-card-prev],[data-card-next]');
    if (nav) {
      e.preventDefault();
      const card = nav.closest('[data-card]');
      const src = card.querySelector('[data-card-images]');
      const img = card.querySelector('[data-card-img]');
      if (!src || !img) return;
      const list = src.textContent.split('|').map((x) => x.trim()).filter(Boolean);
      let i = parseInt(card.dataset.idx || '0', 10);
      i = (i + (nav.hasAttribute('data-card-next') ? 1 : -1) + list.length) % list.length;
      card.dataset.idx = i;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = list[i].startsWith('//') ? 'https:' + list[i] : list[i];
      return;
    }
    const cartBtn = e.target.closest('[data-card-cart]');
    if (cartBtn) {
      e.preventDefault();
      const card = cartBtn.closest('[data-card]');
      const panel = card.querySelector('[data-card-sizes]');
      if (cartBtn.dataset.variant) { await quickAdd(cartBtn.dataset.variant, cartBtn); return; }
      if (panel) {
        const open = panel.hidden;
        $$('[data-card-sizes]').forEach((p) => { p.hidden = true; });
        $$('[data-card-cart]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        panel.hidden = !open; cartBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    const sizeBtn = e.target.closest('[data-card-sizes] button[data-variant]');
    if (sizeBtn) {
      e.preventDefault();
      const card = sizeBtn.closest('[data-card]');
      await quickAdd(sizeBtn.dataset.variant, card.querySelector('[data-card-cart]'));
      card.querySelector('[data-card-sizes]').hidden = true;
      return;
    }
    if (!e.target.closest('[data-card]')) {
      $$('[data-card-sizes]').forEach((p) => { p.hidden = true; });
      $$('[data-card-cart]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
  });
  /* desktop: hover otvara veličine (kao USPA shopovi) */
  if (window.matchMedia('(hover:hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest && e.target.closest('[data-card]');
      if (!card || card.dataset.hovered) return;
      card.dataset.hovered = '1';
      const p = card.querySelector('[data-card-sizes]'); if (p) p.hidden = false;
      card.addEventListener('mouseleave', () => { delete card.dataset.hovered; if (p) p.hidden = true; }, { once: true });
    });
  }
  async function quickAdd(id, btn) {
    try {
      if (btn) btn.disabled = true;
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: 1 }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Greška');
      if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1500); }
      await refreshCartDrawer();
      openDrawer('MbCartDrawer');
    } catch (err) { window.alert(err.message); }
    finally { if (btn) btn.disabled = false; }
  }

  /* ---------- Cart drawer (section rendering) ---------- */
  async function refreshCartDrawer() {
    const d = $('#MbCartDrawer');
    if (!d) return;
    const r = await fetch(window.location.pathname + '?section_id=mb-cart-drawer');
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#MbCartDrawer');
    if (fresh) d.innerHTML = fresh.innerHTML;
    const count = doc.querySelector('[data-cart-count]');
    $$('[data-cart-count]').forEach((c) => { c.textContent = count ? count.textContent : '0'; c.hidden = !count || count.textContent === '0'; });
  }
  window.mbRefreshCart = refreshCartDrawer;

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    const line = b.dataset.line; let qty = parseInt(b.dataset.qty, 10);
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }) });
    if (b.closest('#MbCartDrawer')) refreshCartDrawer(); else window.location.reload();
  });

  /* ---------- Announcement: smjenjujuće poruke ---------- */
  $$('[data-usp-rotate]').forEach((ul) => {
    const items = $$('li', ul).filter((li) => getComputedStyle(li).display !== 'none' || true);
    if (!items.length) return;
    let i = 0; items[0].classList.add('is-on'); ul.classList.add('is-ready');
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4000);
  });

  /* ---------- Pretraga: mobilni toggle ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-toggle]');
    if (!t || window.matchMedia('(min-width: 900px)').matches) return;
    e.preventDefault();
    const h = t.closest('.mb-header'); if (!h) return;
    const open = h.classList.toggle('is-search-open');
    if (open) { const inp = $('.mb-header__search input[type="search"]', h); if (inp) setTimeout(() => inp.focus(), 30); }
  });

  /* ---------- Predictive search (Shopify /search/suggest.json) ---------- */
  $$('form[data-predictive]').forEach((form) => {
    const input = $('input[type="search"]', form);
    const box = $('.mb-predict', form);
    if (!input || !box) return;
    const base = form.dataset.predictive || '/search/suggest';
    let timer, ctrl, active = -1;
    const esc = (t) => String(t || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const clean = (u) => String(u || '').split('?')[0];
    const money = (v) => { const n = parseFloat(v); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' KM'; };
    const hl = (text, q) => { const t = esc(text); const words = q.trim().split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); return words.length ? t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>') : t; };
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function render(q, res) {
      const r = (res && res.resources && res.resources.results) || {};
      const qs = (r.queries || []).slice(0, 4), cs = (r.collections || []).slice(0, 4), ps = (r.products || []).slice(0, 6);
      let html = '';
      if (qs.length) html += '<div class="mb-predict__grp"><span class="mb-predict__t">Prijedlozi</span>' + qs.map((x) => '<a role="option" href="/search?q=' + encodeURIComponent(x.text) + '&type=product">' + hl(x.text, q) + '</a>').join('') + '</div>';
      if (cs.length) html += '<div class="mb-predict__grp"><span class="mb-predict__t">Kategorije</span>' + cs.map((x) => '<a role="option" href="' + esc(clean(x.url)) + '">' + hl(x.title, q) + '</a>').join('') + '</div>';
      if (ps.length) html += '<div class="mb-predict__grp"><span class="mb-predict__t">Proizvodi</span>' + ps.map((x) => {
        const img = x.featured_image && x.featured_image.url ? '<img src="' + esc(x.featured_image.url) + (x.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="44" height="55">' : '';
        const cmp = parseFloat(x.compare_at_price_max || 0) > parseFloat(x.price || 0) ? '<s>' + money(x.compare_at_price_max) + '</s>' : '';
        return '<a role="option" href="' + esc(clean(x.url)) + '"><span class="mb-predict__img">' + img + '</span><span class="mb-predict__m"><span>' + hl(x.title, q) + '</span><span class="mb-predict__p"><span class="' + (cmp ? 's' : '') + '">' + money(x.price) + '</span>' + cmp + '</span></span></a>';
      }).join('') + '</div>';
      if (!html) html = '<div class="mb-predict__empty">Nema prijedloga za „' + esc(q) + '“.</div>';
      html += '<a class="mb-predict__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Prikaži sve rezultate za „' + esc(q) + '“</a>';
      box.innerHTML = html; box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
    }
    input.addEventListener('input', () => {
      const q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(async () => {
        try {
          if (ctrl) ctrl.abort(); ctrl = new AbortController();
          const url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
          const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
          if (!r.ok) return;
          render(q, await r.json());
        } catch (err) { /* prekinut zahtjev */ }
      }, 220);
    });
    input.addEventListener('keydown', (e) => {
      const links = $$('a', box);
      if (box.hidden || !links.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach((l, i) => l.classList.toggle('is-active', i === active));
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location.href = links[active].href; }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
  });
})();
